type WrapAround = (value: number, range: [min: number, max: number]) => number

export const wrapAround: WrapAround = (value, [min, max]) =>
  ((((value - min) % (max - min)) + (max - min)) % (max - min)) + min
